import './debugLog'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { applyDarkModeFromStorage, bindDarkModeShortcut } from './lib/darkMode'
import { clearTelemetryCacheIfAppVersionChanged } from './lib/appVersion'
import App from './App'
import reportWebVitals from './reportWebVitals'

applyDarkModeFromStorage()
bindDarkModeShortcut()

const root = ReactDOM.createRoot(document.getElementById('root'))

async function boot() {
  try {
    await clearTelemetryCacheIfAppVersionChanged()
  } catch (_) {
    // IndexedDB failures must not block the app; the next load will retry.
  }
  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  )
}

boot()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
